import { useEffect, useState } from "react";
import { checkUserExists, signupWithMagicURL } from "../service/auth";
import { validateEmail } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import ConfettiBG from "../components/ConfettiBg";
import Logo from "../components/Logo";

import BgPattern from "../components/BgPattern";
import LoadingScreen from "../components/Loading";
import EmailVerificationAlert from "../components/EmailVerificationAlert";

const Home = () => {
	const [showLoading, setshowLoading] = useState(true);
	const [showVerificationAlert, setshowVerificationAlert] = useState(false);
	const [input, setInput] = useState({
		email: "",
		name: "",
	});
	const [invalidEmail, setInvalidEmail] = useState(false);
	const navigate = useNavigate();

	//check if user exists
	useEffect(() => {
		checkUserExists().then((exist) => {
			if (exist) {
				navigate("/dashboard");
			}
			console.log(exist);
		});
		setshowLoading(false);
	}, []);

	const handleInputChange = (e) => {
		setInput({ ...input, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!validateEmail(input.email)) {
			console.log("Invalid email");
			setInvalidEmail(true);
			return;
		} else {
			setInvalidEmail(false);
		}

		// Rest of the signup logic
		// console.log(input);
		setshowLoading(true)
		signupWithMagicURL(
			input.email,
			(user) => {
				setshowLoading(false);
				setshowVerificationAlert(true);
				
			},
			(e) => {
				console.log(e);
				setshowLoading(false)
			}
		);
	};

	return (
		<div className="bg-[#0b0022] relative h-full w-full flex flex-col items-center justify-center overflow-hidden ">
			<BgPattern rotate className="absolute top-0 left-0 w-full h-full opacity-30 "></BgPattern>
			<ConfettiBG></ConfettiBG>
			<LoadingScreen show={showLoading}></LoadingScreen>
			<div className="relative z-[2] ">
				<div className="flex flex-col items-center">
					<h1 className="text-[2.6rem] font-custom font-black text-white">TellMeBefore24</h1>
					<h5 className=" font-custom font-bold text-white">Hear What They Have to Say Before 2024!</h5>
				</div>

				<div className="h-[2rem]"></div>
				{/* <CountdownTimer></CountdownTimer> */}
				<img className="absolute w-full h-full  object-cover  scale-[1.7] z-[0]" src={require("../assets/whitepaper.png")} alt="paper" />
				<form onSubmit={handleSubmit} className="min-w-[250px] z-[2] h-full flex flex-col justify-center relative">
					{invalidEmail && <p style={{ color: "red" }}>Invalid email</p>}
					<input type="email" name="email" value={input.email} onChange={handleInputChange} placeholder="Enter your email" className="bg-transparent border-4 border-gray-600  font-bold rounded-md p-2 outline-none" />
					<div className="h-[2rem]"></div>
					{/* <input type="email" name="email" value={input.email} onChange={handleInputChange} placeholder="Enter your email" className="bg-transparent border-2 border-white rounded-md p-2 outline-none" /> */}
					{/* <div className="h-[2rem]"></div> */}
					<button type="submit" className="bg-red-500 active:bg-orange-700 w-full rounded-full py-3 outline-none focus:border-pink-500 transition duration-300 shadow-md text-white font-bold text-lg">
						Enter
					</button>
				</form>
			</div>
			{/* <img className="absolute   bottom-0 opacity-15 -z-1" src={require("../assets/golden_tree.png")} alt="tree" /> */}
			<img className="absolute h-[70%] -left-[200px] -bottom-10 brightness-[0.3]  z-[1]" src={require("../assets/tree2.webp")} alt="tree" />
			<img className="absolute h-[70%] -right-[200px] -bottom-10 brightness-[0.2] z-[1]" src={require("../assets/tree2.webp")} alt="tree" />
			{showVerificationAlert && <EmailVerificationAlert onClose={() => setshowVerificationAlert(false)}></EmailVerificationAlert>}
			<Logo className="absolute bottom-0 z-50"></Logo>
		</div>
	);
};

export default Home;
